export const RoutePaths = {
  pageHome: "",
  pageHomeNoParam: "/",

  /* AUTHEN */
  pageAuth: "auth/:social",
  pageAuthNoParam: "/auth/",
  /* END */

  /* PLANS */
  pagePlanList: "list",
  pagePlanListNoParam: "/list",
  pagePlanListParam: "list/:targetDay",
  pagePlanListCityParam: "list/:city/:targetDay",
  pagePlanListCityTownParam: "list/:city/:town/:targetDay",
  pagePlanListCityTownServiceParam: "list/:city/:town/:targetDay/:services",
  pagePlanListCityTownServiceOfficeParam:
    "list/:city/:town/:targetDay/:services/:office",
  /* END */

  pagePlanDetail: "searches/detail/:planCode",
  pagePlanDetailNoParam: "/searches/detail/",

  /* CART */
  pageCartIndex: "reserves/cart",
  pageCartIndexNoParam: "/reserves/cart",

  pageCartAdd: "searches/cart/add/:planCode",
  pageCartAddNoParam: "/searches/cart/add/",

  pageCartEdit: "searches/cart/edit/:planCode",
  pageCartEditNoParam: "/searches/cart/edit/",
  /* END */

  /* RESERVES */
  pageReserveIndex: "reserves",
  pageReserveIndexNoParam: "/reserves",

  pageReserveFinish: "reserves/accept",
  pageReserveFinishNoParam: "/reserves/accept",

  pageReserveInsurance: "reserves/insurance",
  pageReserveInsuranceNoParam: "/reserves/insurance",

  pageReservePassengerPlan1: "reserves/passenger",
  pageReservePassengerPlan1NoParam: "/reserves/passenger",

  pageReservePassengerPlan2: "reserves/passenger-plan-2",
  pageReservePassengerPlan2NoParam: "/reserves/passenger-plan-2",

  pageReservePayment: "reserves/payment",
  pageReservePaymentNoParam: "/reserves/payment",

  pageReserveCheckout: "reserves/checkout",
  pageReserveCheckoutNoParam: "/reserves/checkout",

  pageReserveSeatMapPlan1: "reserves/seat-map",
  pageReserveSeatMapPlan1NoParam: "/reserves/seat-map",

  pageReserveSeatMapPlan2: "reserves/seat-map-plan-2",
  pageReserveSeatMapPlan2NoParam: "/reserves/seat-map-plan-2",
  /* END */

  /* MY PAGES */
  pageMyPageIndex: "mypages",
  pageMyPageIndexNoParam: "/mypages",

  pageProfileIndex: "mypages/profile",
  pageProfileIndexNoParam: "/mypages/profile",

  pageReservationList: "mypages/reservations",
  pageReservationListWithPage: "mypages/reservations/:page",
  pageReservationListNoParam: "/mypages/reservations",

  pageReservationDetail: "mypages/reservation/:reservationID",
  pageReservationDetailNoParam: "/mypages/reservation/",

  pageReservationChange: "mypages/reservation/change/:reservationID",
  pageReservationChangeNoParam: "/mypages/reservation/change/",

  pageReservationConfirm: "mypages/reservation/confirm/:reservationID",
  pageReservationConfirmNoParam: "/mypages/reservation/confirm/",

  pageReceiptList: "mypages/receipts",
  pageReceiptListWithPage: "mypages/receipts/:page",
  pageReceiptListNoParam: "/mypages/receipts",

  pageReservationWebTicket: "mypages/reservation/webticket/:reservationID",
  pageReservationWebTicketNoParam: "/mypages/reservation/webticket/",

  pageReservationEmail: "mypages/reservation/emails/:reservationID",
  pageReservationEmailWithPage:
    "mypages/reservation/emails/:reservationID/:page",
  pageReservationEmailNoParam: "/mypages/reservation/emails/",

  pageEmailList: "mypages/emails",
  pageEmailListWithPage: "mypages/emails/:page",
  pageEmailListNoParam: "/mypages/emails",

  /* AREA */
  pageAreaIndex: "area",
  pageAreaIndexNoParam: "/area/",
  pageAreaCityDetailIndex: "area/:city",
  pageAreaTownDetailWithTownIndex: "area/:city/:areaTown",

  /* INFO PAGES */
  pageInfoIndex: "info",
  pageInfoIndexNoParam: "/info",

  pageInfoCancelIndex: "info/cancel",
  pageInfoCancelIndexNoParam: "/info/cancel",

  pageInfoCompanyIndex: "info/company",
  pageInfoCompanyIndexNoParam: "/info/company",

  pageInfoFaqsIndex: "info/faqs",
  pageInfoFaqsIndexNoParam: "/info/faqs",

  pageInfoMemberRuleIndex: "info/member-rule",
  pageInfoMemberRuleIndexNoParam: "/info/member-rule",

  pageInfoPayIndex: "info/pay",
  pageInfoPayIndexNoParam: "/info/pay",

  pageInfoPrivacyPolicyIndex: "info/privacy-policy",
  pageInfoPrivacyPolicyIndexNoParam: "/info/privacy-policy",

  pageInfoSiteRuleIndex: "info/site-rule",
  pageInfoSiteRuleIndexNoParam: "/info/site-rule",

  pageInfoTokusyoIndex: "info/tokusyo",
  pageInfoTokusyoIndexNoParam: "/info/tokusyo",

  pageInfoRefundIndex: "info/refund/update/:id",
  pageInfoRefundIndexNoParam: "/info/refund/update/",
  pageInfoRefundCheckout: "info/refund/checkout",
  pageInfoRefundFinish: "info/refund/accept",

  pageInfoYakkanIndex: "info/yakkan",
  pageInfoYakkanIndexNoParam: "/info/yakkan",

  /* STATION */
  pageStationDetail: "sites/map/:travelID/:stationID",
  pageStationDetailD: "sites/map/:travelID/:stationID/d",
  pageStationDetailWithPlanCode: "sites/map/:travelID/:stationID/:planCode",
  pageStationDetailWithPlanCodeD: "sites/map/:travelID/:stationID/:planCode/d",
  pageStationDetailWithDate:
    "sites/map/:travelID/:stationID/:planCode/:targetDay",
  pageStationDetailWithDateD:
    "sites/map/:travelID/:stationID/:planCode/:targetDay/d",
  pageStationDetailNoParam: "/sites/map/",
};
